'use client';

import { usePathname } from 'next/navigation';
import dynamic from 'next/dynamic';

// Constants
import { IMAGES, ROUTES } from '@shared/constants';

// Providers
import { useFirebase } from '@/providers/firebase';

// Components
import { Header } from '@/components/layout/Header';

// UI
const UserMenu = dynamic(() => import('@/components/UserMenu'), {
  ssr: false
});
const WithCopilotKitHeadless = dynamic(() => import('@/ui/SearchBarWithAI/WithCopilotKitHeadless').then(mod => mod.WithCopilotKitHeadless), {
  ssr: false
});
export const BuilderHeader = () => {
  const pathname = usePathname();
  const {
    user,
    getToken
  } = useFirebase();
  const userEmail = user?.email || '';
  const userId = user?.uid || '';
  const shouldHideSearchBar = [ROUTES.HOME, ROUTES.NOT_FOUND].includes(pathname);
  return <Header logo={{
    src: {
      lightMode: IMAGES.LOGO_AGILITY
    },
    alt: 'Logo of the application',
    width: 102,
    height: 26
  }} className="bg-white mx-0 flex items-center justify-between h-header-sm" classCustom="mx-0 px-6 py-[7px] md:px-7.5" href={userId ? ROUTES.HOME : ROUTES.SIGN_IN} endSlot={{
    element: <div className="flex items-center justify-between gap-3 sm:gap-6.25">
            {!shouldHideSearchBar && <WithCopilotKitHeadless getToken={getToken} email={userEmail} />}
            <UserMenu />
          </div>
  }} data-sentry-element="Header" data-sentry-component="BuilderHeader" data-sentry-source-file="BuilderHeader.tsx" />;
};